import "./css/headerCmp.css";
import {Theme, presetGpnDefault} from "@consta/uikit/Theme";
import React, {useEffect, useRef, useState} from "react";
import {IconRing} from "@consta/uikit/IconRing";
import {
    Header,
    HeaderButton,
    HeaderLogin,
    HeaderLogo,
    HeaderMenu,
    HeaderModule,
} from "@consta/uikit/Header";
import {ContextMenu} from '@consta/uikit/ContextMenu';
import ExcelUploader from "./importXLS.cmp";
import axios from "axios";

import {useQuery} from "@tanstack/react-query";
import ReportToExcel from "../page/report/component/export.report.func";
import {canManageAccess, canUseModule} from "../service/authAccess";

export let username: string | null;


type ItemLogout = {
    label: string;
    event?: () => void;
};

const MENU_HASH: Record<string, string> = {
    "Ремонты": "#repairs",
    "Экипажи": "#equipages",
    "БСИ": "#bsi",
    "График": "#graph",
    "Обрывы": "#cliff",
    "ППК": "#ppk",
    "Заявки КС": "#control-requests",
    "Задвижки": "#valves",
    "Закрытие КА": "#contractor-closure",
    "Отчеты": "#reports",
    "Логи": "#logs",
    "Настройки": "#settings",
};

const MENU_MODULES: Record<string, string> = {
    "Ремонты": "repairs",
    "Экипажи": "equipages",
    "БСИ": "bsi",
    "График": "graph",
    "Обрывы": "cliff",
    "ППК": "ppk",
    "Заявки КС": "control_requests",
    "Задвижки": "valves",
    "Закрытие КА": "contractor_closure",
    "Отчеты": "reports",
    "Логи": "logs",
    "Настройки": "settings",
};

const canUseMenuItem = (label: string) => {
    const moduleId = MENU_MODULES[label];
    if (!moduleId) {
        return false;
    }

    return canUseModule(moduleId);
};

const HeaderCmp = (props: { selectedMenuItem: string | null, setSelectedMenuItem: (selectedItem: string | null) => void }) => {
    const [orgname, setOrgname] = useState<any>()
    const handleMenuItemClick = (item: string) => {
        props.setSelectedMenuItem(item);
    };
    const [value, setValue] = useState<string | null>(null);
    const [isOpenLogout, setIsOpenLogout] = useState<boolean>(false);
    const handleSearch = (value: string | null) =>
        alert(`Произведен поиск, запрос - ${value} `);
    const ref = useRef(null);
    //
    // const {isPending, error, data, refetch} = useQuery({
    //     queryKey: ['diagramData'],
    //     queryFn: () =>
    //         axios.get(API_REPORTS_REPORT1, {params: {date: '111'}}).then(
    //             (res) => {
    //                 return res.data
    //             },
    //         ),
    // })


    const itemsLogout: ItemLogout[] = [
        {
            label: 'Выйти',
            event: () => {
                handleLogout()
            },
        },
    ];

    let menuItems = [
        {
            label: "Ремонты",
            href: MENU_HASH["Ремонты"],
            active: props.selectedMenuItem === "Ремонты",
            onClick: () => handleMenuItemClick("Ремонты"),
        },
        {
            label: "Экипажи",
            href: MENU_HASH["Экипажи"],
            active: props.selectedMenuItem === "Экипажи",
            onClick: () => handleMenuItemClick("Экипажи"),
        },
        {
            label: "БСИ",
            href: MENU_HASH["БСИ"],
            active: props.selectedMenuItem === "БСИ",
            onClick: () => handleMenuItemClick("БСИ"),
        },
        {
            label: "График",
            href: MENU_HASH["График"],
            active: props.selectedMenuItem === "График",
            onClick: () => handleMenuItemClick("График"),
        },
        {
            label: "Обрывы",
            href: MENU_HASH["Обрывы"],
            active: props.selectedMenuItem === "Обрывы",
            onClick: () => handleMenuItemClick("Обрывы"),
        },
        {
            label: "ППК",
            href: MENU_HASH["ППК"],
            active: props.selectedMenuItem === "ППК",
            onClick: () => handleMenuItemClick("ППК"),
        },
        {
            label: "Заявки КС",
            href: MENU_HASH["Заявки КС"],
            active: props.selectedMenuItem === "Заявки КС",
            onClick: () => handleMenuItemClick("Заявки КС"),
        },
        {
            label: "Задвижки",
            href: MENU_HASH["Задвижки"],
            active: props.selectedMenuItem === "Задвижки",
            onClick: () => handleMenuItemClick("Задвижки"),
        },
    ].filter((item) => canUseMenuItem(item.label));
    if (canUseMenuItem("Закрытие КА")) {
        menuItems = [...menuItems, {
            label: "Закрытие КА",
            href: MENU_HASH["Закрытие КА"],
            active: props.selectedMenuItem === "Закрытие КА",
            onClick: () => handleMenuItemClick("Закрытие КА"),

        }]
    }
    if (canUseMenuItem("Отчеты")) {
        menuItems = [...menuItems, {
            label: "Отчеты",
            href: MENU_HASH["Отчеты"],
            active: props.selectedMenuItem === "Отчеты",
            onClick: () => handleMenuItemClick("Отчеты"),

        }]
    }
    if (canUseMenuItem("Логи")) {
        menuItems = [...menuItems, {
            label: "Логи",
            href: MENU_HASH["Логи"],
            active: props.selectedMenuItem === "Логи",
            onClick: () => handleMenuItemClick("Логи"),

        }]
    }
    if (canManageAccess()) {
        menuItems = [...menuItems, {
            label: "Настройки",
            href: MENU_HASH["Настройки"],
            active: props.selectedMenuItem === "Настройки",
            onClick: () => handleMenuItemClick("Настройки"),

        }]
    }

    useEffect(() => {
        if (localStorage.getItem('username')) {
            username = localStorage.getItem('username');
            setOrgname(localStorage.getItem('userDisplayName') || username);
        }
    }, []);


    const getItemOnClickLogout = (item: ItemLogout) => {
        if (item.event) {
            return item.event;
        }
        return () => alert(item.label);
    };

    const handleLogout = () => {
        localStorage.setItem('accessToken', '')
        localStorage.removeItem('company');
        localStorage.setItem('username', '');
        localStorage.setItem('userDisplayName', '');
        localStorage.setItem('refreshToken', '');
        window.location.reload()
    }


    return (

        <div className="headerContainer">
            <Theme className="headerCmp" preset={presetGpnDefault}>
                <Header
                    leftSide={
                        <>
                            <HeaderModule>
                                <HeaderLogo>
                                    <img
                                        // src="/pic/Logo_aspo.png" style={{position: 'relative', width: '430px'}}
                                        src="/pic/ASPO_ONLY.png" style={{position: 'relative', width: '150px'}}

                                        alt="Логотип"/>
                                </HeaderLogo>
                            </HeaderModule>

                            <HeaderModule indent="l">
                                <HeaderMenu items={menuItems}/>
                            </HeaderModule>
                        </>
                    }
                    rightSide={
                        <>
                            {canManageAccess() &&
                                <>
                                    {/*<HeaderModule indent="s">*/}
                                    {/*    <HeaderButton iconLeft={IconRing} onClick={handleReportClick}/>*/}
                                    {/*</HeaderModule>*/}
                                    <HeaderModule indent="s">
                                        <ExcelUploader/>
                                    </HeaderModule>
                                </>
                            }

                            <HeaderModule indent="s">
                                <HeaderLogin
                                    isLogged={true}
                                    personName={orgname}
                                    // personInfo="В другом офисе"
                                    personStatus="available"
                                    onClick={() => setIsOpenLogout(!isOpenLogout)}
                                    // isMinified
                                    ref={ref}
                                />
                                <ContextMenu isOpen={isOpenLogout}
                                             items={itemsLogout}
                                             onClickOutside={() => setIsOpenLogout(false)}
                                             anchorRef={ref}
                                             getItemOnClick={getItemOnClickLogout}/>

                            </HeaderModule>
                        </>
                    }
                />
            </Theme>
        </div>
    )
}

export default HeaderCmp;
